import React, { useState } from 'react';
import { motion } from 'framer-motion';
import classnames from 'classnames/bind';
import { ChevronIcon } from 'components/icon/Icon';

import s from './AccordionContainer.module.scss';

interface PowerPackageCardProps {
  children: React.ReactNode;
  title?: string;
}

const AccordionContainer = (props: PowerPackageCardProps) => {
  const c = classnames.bind(s);

  const { title, children } = props;
  const [toggle, setToggle] = useState(false);

  return (
    <motion.div
      className={c(s.accordionContainer, {
        [s.accordionContainer__active]: toggle,
      })}
      animate={{ backgroundColor: toggle ? '#FDFDFD' : '#F3F1F4' }}
      transition={{ duration: 0.2 }}
    >
      <button
        onClick={() => setToggle(!toggle)}
        className={s.accordionContainer__button}
      >
        <h3 className={s.accordionContainer__title}>
          {title ?? 'Velja orkuleið'}
        </h3>

        <motion.div
          className={s.accordionContainer__svg}
          animate={{ rotate: toggle ? 0 : 180 }}
          transition={{ duration: 0.2 }}
        >
          <ChevronIcon />
        </motion.div>
      </button>
      <div
        style={{
          opacity: toggle ? 1 : 0,
          height: toggle ? 'auto' : 0,
          pointerEvents: toggle ? 'auto' : 'none',
        }}
      >
        {children}
      </div>
    </motion.div>
  );
};
export default AccordionContainer;
